/**
 * Color tranformation
 */
function getHexValue(intInput) {
    var result = intInput.toString(16);
    if (result.length < 2) {
        result = '0' + result;
    }
    return result;
}
export function Color(red, green, blue, alpha) {
    return {
        red: red,
        green: green,
        blue: blue,
        alpha: alpha,
        toHex: function () {
            return getHexValue(red) + getHexValue(green) + getHexValue(blue);
        }
    };
}
var ɵ0 = function (color, bgColor) {
    var alpha = color.alpha;
    function getTintValue(tint, bgTint) {
        var tmp = Math.floor((1 - alpha) * bgTint + alpha * tint);
        if (tmp > 255) {
            return 255;
        }
        return tmp;
    }
    return Color(getTintValue(color.red, bgColor.red), getTintValue(color.green, bgColor.green), getTintValue(color.blue, bgColor.blue));
};
// Converter which actually does the calculation from rgba to hex.
var colorConverter = {
    // Converts the given color to a Color object, using the given gbColor in the calculation.
    convertToHex: ɵ0
};
function hue2rgb(p, q, t) {
    if (t < 0) {
        t += 1;
    }
    if (t > 1) {
        t -= 1;
    }
    if (t < 1 / 6) {
        return p + (q - p) * 6 * t;
    }
    if (t < 1 / 2) {
        return q;
    }
    if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
}
var ɵ1 = function (rgba) {
    // Strip the rgba-definition off the string.
    rgba = rgba.replace('rgba(', '')
        .replace(')', '')
        .replace(' ', '');
    // Split the rgba string into an array.
    var splittedRgba = rgba.split(',');
    return Color(parseInt(splittedRgba[0], 10), parseInt(splittedRgba[1], 10), parseInt(splittedRgba[2], 10), parseFloat(splittedRgba[3]) || 1);
}, ɵ2 = function (hexString) {
    hexString = hexString.replace('#', '');
    var rgbArr = [], hexPair;
    function getHexPartByIndex(index) {
        switch (hexString.length) {
            case 3:
                return hexString[index] + hexString[index];
            default:
                index *= 2;
                return hexString[index] + hexString[index + 1];
        }
    }
    // String the "#" off the hex-string.
    hexString = hexString.replace('#', '');
    // Convert pairs of hex-characters into decimal numbers.
    for (var i = 0; i < hexString.length; i++) {
        rgbArr.push(parseInt(getHexPartByIndex(i), 16));
    }
    return Color(rgbArr[0], rgbArr[1], rgbArr[2], 1);
}, ɵ3 = function hslToRgb(hsla) {
    hsla = hsla.replace('hsla(', '')
        .replace('hsl(', '')
        .replace(')', '')
        .replace(' ', '');
    // Split the hsla string into an array.
    hsla = hsla.split(',');
    var h = parseInt(hsla[0], 10) / 360;
    var s = parseInt(hsla[1], 10) / 100;
    var l = parseInt(hsla[2], 10) / 100;
    var a = parseFloat(hsla[3]) || 1;
    var r, g, b;
    if (s == 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return Color(Math.round(r * 255), Math.round(g * 255), Math.round(b * 255), a);
};
var colorStringParser = {
    // Converter for rgb(a) colors
    rgba: ɵ1,
    // Converter for hex colors
    hex: ɵ2,
    // Converter for hsl(a) colors.
    hsla: ɵ3
};
// Returns the type of color based on the given string.
function getColorType(colorString) {
    if (colorString.indexOf('rgba') !== -1 || colorString.indexOf('rgb') !== -1) {
        return 'rgba';
    }
    if (colorString.indexOf('hsla') !== -1 || colorString.indexOf('hsl') !== -1) {
        return 'hsla';
    }
    return 'hex';
}
// Convenience function that returns the Color object for the given inputString.
function getColorForString(inputString) {
    return colorStringParser[getColorType(inputString)](inputString);
}
export function trim(str) {
    return str.replace(/^\s+|\s+$/gm, '');
}
export function rgbaToHex(rgba) {
    var parts = rgba.substring(rgba.indexOf('(')).split(','), r = parseInt(trim(parts[0].substring(1)), 10), g = parseInt(trim(parts[1]), 10), b = parseInt(trim(parts[2]), 10), a = parseFloat(trim(parts[3].substring(0, parts[3].length - 1))).toFixed(2);
    return ('#' + r.toString(16) + g.toString(16) + b.toString(16) + (Number(a) * 255).toString(16).substring(0, 2));
}
export function componentToHex(c) {
    c = Number(c);
    var hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
// for shadow
export function toRgb(str, alpha) {
    return hexToRgba(colorConverter.convertToHex(getColorForString(str), getColorForString('#ffffff')).toHex(), alpha || 1);
}
export function converterToHex(str) {
    return colorConverter.convertToHex(getColorForString(str), getColorForString('#ffffff')).toHex();
}
export function rgbToHex(rgb) {
    var toRgb = rgb;
    if (toRgb.substr(0, 4) === 'rgba') {
        toRgb = toRgb.slice(5);
    }
    else {
        toRgb = toRgb.slice(4);
    }
    toRgb = toRgb.slice(0, -1);
    toRgb = toRgb.replace(' ', '');
    toRgb = toRgb.split(',');
    return componentToHex(toRgb[0]) + componentToHex(toRgb[1]) + componentToHex(toRgb[2]);
}
export function rgbTransparent(rgba) {
    if (typeof rgba === 'string') {
        rgba = rgba.slice(0, -1);
        rgba = (rgba.split(',')[3]) * 1;
        if (typeof rgba === 'number') {
            rgba = 1;
        }
    }
    else {
        rgba = 1;
    }
    return rgba;
}
export function hexToRgba(hex, tr) {
    if (tr === void 0) { tr = -1; }
    var _default = hex;
    var transparent = {
        r: 0,
        g: 0,
        b: 0,
        a: 0
    };
    if (tr === -1) {
        tr = rgbTransparent(hex);
    }
    hex = String(hex);
    if ((hex.substr(0, 4) === 'rgba') && !!hex.split(',')[3]) {
        tr = parseFloat(hex.split(',')[3].replace(')', ''));
        hex = String(hex);
        if (hex.length !== 6 && hex.length !== 3) {
            hex = rgbToHex(hex);
        }
    }
    if (hex !== undefined && hex !== null && hex !== 'transparent') {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        var colorr = 0;
        var colorg = 0;
        var colorb = 0;
        if (result) {
            colorr = parseInt(result[1], 16);
            colorg = parseInt(result[2], 16);
            colorb = parseInt(result[3], 16);
        }
        return result ? {
            json: {
                r: colorr,
                g: colorg,
                b: colorb,
                a: tr
            },
            color: "rgba(" + colorr + ", " + colorg + ", " + colorb + ", " + tr + ")",
        } : {
            json: transparent,
            color: "" + _default,
        };
    }
    else {
        return {
            json: transparent,
            color: "rgba(" + 0 + ", " + 0 + ", " + 0 + ", " + 0 + ")",
        };
    }
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
//# sourceMappingURL=color-tranformation.js.map